<template>
  <v-card>
    <v-card-text>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="headline">Negociações</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn link color="primary"
                 v-if="!isFinalizada"
          :to="`/cotacao-conjunta/${idCotacao}/resposta/${solicitacao.respostaCotacaoConjunta.id}`">
            Alterar minha proposta
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <div class="text--primary mt-3">
        <px-acompanhamentos allow-files hide-input-on-empty
                            :disabled="isFinalizada"
                            :item-type="messageType"
                            :user="user"
                            :item-id="solicitacao.respostaCotacaoConjunta.id"
                            @on-message="onMessage">
        </px-acompanhamentos>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import CotacaoConjuntaResposta from '../cotacao-conjunta-resposta.service';

export default {
  props: {
    solicitacao: Object,
    idCotacao: [String, Number],
    isFinalizada: Boolean,
  },
  computed: {
    ...mapGetters('user', ['user']),
  },
  data() {
    return {
      messageType: this.$px.types.NEGOCIACAO_COTACAO_CONJUNTA,
    };
  },
  methods: {
    onMessage() {
      CotacaoConjuntaResposta.notificarNegociacao(this.solicitacao.respostaCotacaoConjunta.id);
    },
  },
};
</script>
